import config from '../config';

function parseApiError(data, fallback) {
  const detail = data.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d.msg || d).join('; ');
  }
  return fallback;
}

/**
 * @param {string} username
 * @param {string} password
 */
export async function login(username, password) {
  const response = await fetch(`${config.apiBaseUrl}/v1/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });

  let data = {};
  try {
    data = await response.json();
  } catch {
    /* 非 JSON 响应 */
  }

  if (!response.ok) {
    throw new Error(parseApiError(data, '登录失败，请检查账号和密码'));
  }

  return data;
}

/**
 * @param {{ username: string; password: string; name?: string }} payload
 */
export async function register({ username, password, name }) {
  const response = await fetch(`${config.apiBaseUrl}/v1/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password, name: name || undefined }),
  });

  let data = {};
  try {
    data = await response.json();
  } catch {
    /* 非 JSON 响应 */
  }

  if (!response.ok) {
    throw new Error(parseApiError(data, '注册失败，请检查填写信息'));
  }

  return data;
}
